module.exports = __webpack_public_path__ + "img/hill13.8bce7351.jpg";